import { BaseData } from './base-data'
import { HubInfoID } from './id/hub_info_id'
import { SubtleBadgeProps } from '../../components/common/SubtleBadge'

export enum HubInfoStatus {
  UNKNOWN = 'unknown',
  ERROR = 'error',
  ENABLING = 'enabling',
  READY = 'ready',
  DISABLING = 'disabling',
  DISABLED = 'disabled',
}

export enum HubProductPlan {
  UNKNOWN = 'plan_unknown',
  SHARED = 'plan_shared',
  DEDICATED = 'plan_dedicated',
  HA = 'plan_ha',
}

export const hubInfoProductPlanToLabel = (plan: HubProductPlan): string => {
  switch (plan) {
    case HubProductPlan.SHARED:
      return 'Partagé'
    case HubProductPlan.DEDICATED:
      return 'Dédié'
    case HubProductPlan.HA:
      return 'Haute disponibilité'
    default:
      return 'Unknown'
  }
}

export const isHubInfoStatus = (value: any): value is HubInfoStatus => {
  return Object.values(HubInfoStatus).includes(value)
}

export const getColorForHubInfoStatus = (
  status: HubInfoStatus
): SubtleBadgeProps['bg'] => {
  switch (status) {
    case HubInfoStatus.ERROR:
      return 'danger'
    case HubInfoStatus.ENABLING:
      return 'warning'
    case HubInfoStatus.READY:
      return 'success'
    case HubInfoStatus.DISABLING:
      return 'warning'
    case HubInfoStatus.DISABLED:
      return 'warning'
    default:
      return 'dark'
  }
}

export interface HubInfoModel extends BaseData<HubInfoID> {
  name: string
  status: HubInfoStatus
  productPlan: HubProductPlan
  enabled: boolean
  disableEvents: boolean
  eventsTopicPrefix?: string
  deviceCount: number
  connectedDeviceCount: number
  endpoint: string
}
